import { StreamActions } from "@hotwired/turbo"
import { show_toast } from "./toasts"

StreamActions.toast = function () {
  // Just get the HTML from the template and pass it to the toast function
  const body = Array.from(this.templateContent.children).map((child) => child.outerHTML).join()

  if (this.getAttribute("header")) {
    show_toast(this.getAttribute("header"), body)
  } else {
    show_toast(body)
  }
}
